import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>General Assignment</h1>
        <p>Pages Project</p>
      </header>
    </div>
  );
}

export default App;
